import React, {useEffect, useState} from 'react';
import LogoutIcon from '@mui/icons-material/Logout';
import SettingsIcon from '@mui/icons-material/Settings';
import ConsobLogo from '../../images/Logo Consob.svg';
import Tooltip from "@mui/material/Tooltip";
import User from '../../services/models/output-objs/User';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { Button } from 'react-bootstrap';
import SSOService from '../../services/controllers/login-services/SSOService';

type rankList = {
    name : string;
    rank:number;
    role:string;
}

type navType = {
    user : User,
    refreshToken : boolean
    refreshUserCallBack:any,
    userCallBack: any;
}

const Navbar = (props:navType) => {

    const [role, setRole] = useState(setFirstRole)
    const [roleList, setRoleList]= useState<string[]>(setRoleListFunction)
    const [singleRole, setSingleRole] = useState<boolean>(false)
    const [open, setOpen] = useState(false);
    const [notHomepage, setNotHomepage] = useState<boolean>(checkHomepage);

    useEffect(() => {
        if(props.user && props.user.groups && props.user.groups.length===1){
            setSingleRole(true)
        }
    }, []) // [] means run only ones

    useEffect(() => {
        if(role)
            roleChange(role)
    }, [role])

    function checkHomepage():boolean{
        let path = window.location.pathname
        if(path != '/homepage' && path!= '/')
            return true
        else
            return false
    }

    function setRoleListFunction():string[]{
        if(props.user && props.user.groups && props.user.groups.length>0){
            let roleName : string[]= []
            props.user.groups.forEach(group =>{
                switch(group){
                    case "/STOR-RDU" : roleName.push('Responsabile'); break;
                    case "/STOR-Funz" : roleName.push('Funzionario'); break;
                    case "/STOR-User" : roleName.push('Desk Stor'); break;
                    case "/STOR-Admin" : roleName.push('Desk Stor'); break;
                    case "/STOR-REV" : roleName.push('Revisore'); break;
                }
            })
            return roleName
        }
        else
            return []
    }

    function setFirstRole(){
        if(props.user && props.user.groups && props.user.groups.length>0){
            let sessionRoleStorage = sessionStorage.getItem("ruolo")
            let sessionRole = ''
            if(sessionRoleStorage)
                sessionRole = JSON.parse(sessionStorage.getItem("ruolo") || '')
            let rankList: rankList[] = []
            if(!sessionRole){
                props.user.groups.forEach(group =>{
                    switch(group){
                        case "/STOR-User" : rankList.push({name: 'Desk Stor', rank: 1, role:group}); break;
                        case "/STOR-Admin" : rankList.push({name: 'Desk Stor', rank: 1, role:group}); break;
                        case "/STOR-RDU" : rankList.push({name: 'Responsabile', rank: 2, role:group}); break;
                        case "/STOR-Funz" : rankList.push({name: 'Funzionario', rank: 3, role:group}); break;
                        case "/STOR-REV" : rankList.push({name: 'Revisore', rank: 4, role:group}); break;
                        case "/STOR-Ext" : rankList.push({name:'',rank:1,role:group }); break;
                    }
                })
                rankList = rankList.sort((n1,n2)=>{
                    if(n1.rank > n2.rank)
                        return 1;
                    if(n1.rank < n2.rank)
                        return -1
                    return 0
                })
                sessionStorage.setItem('ruolo', JSON.stringify(rankList[0].role))
                return rankList[0].name
            }
            else{
                switch(sessionRole){
                    case "/STOR-User" : return 'Desk Stor';
                    case "/STOR-Admin" : return 'Desk Stor';
                    case "/STOR-RDU" : return 'Responsabile';
                    case "/STOR-Funz" : return 'Funzionario';
                    case "/STOR-REV" : return 'Revisore';
                }
            }
        }
        else
            return ''
    }

    const userInformation = <div className="font-medium-custom">
        <div><strong>Utente:</strong> {props.user.given_name} {props.user.family_name}</div>
        {/* <div><strong>Email:</strong> {user.email}</div> */}
    </div>

    function logOut() {
        // UserService.doLogout();
        const ssoService = SSOService.getInstance();
        ssoService.doLogout();

    }

    function openConfirmModalLogout(){
        setOpen(true);
    }

    function goToConfig(){
        window.location.href = "/gestione"
    }

    function roleChange(role: string){
        setRole(role)
        let supportUser : User = props.user
        let selectedGroup : string = ''
        switch(role){
            case "Desk Stor" : supportUser.selectedGroup = 'deskStor'; selectedGroup='deskStor'; break;
            case "Responsabile" : supportUser.selectedGroup = 'responsabile'; selectedGroup='/STOR-RDU'; break;
            case "Funzionario" : supportUser.selectedGroup = 'funzionario'; selectedGroup='/STOR-Funz'; break;
            case "Revisore" : supportUser.selectedGroup = 'revisore'; selectedGroup='/STOR-REV'; break;
        }
        if(selectedGroup === 'deskStor' && supportUser && supportUser.groups){
            supportUser.groups.map(group =>{
                if(group === '/STOR-User' || group === '/STOR-Admin')
                    selectedGroup=group
            })
        }
        sessionStorage.setItem('ruolo', JSON.stringify(selectedGroup));
        props.userCallBack(supportUser)
        props.refreshUserCallBack(!props.refreshToken)
    }

    const handleConfirm = () => {
        logOut();
        setOpen(false);
    }

    const handleCancel = () => {
        setOpen(false)
    }

    return (
        <div className="navbar">
            {singleRole?
                <div id="top-row" className="row col-12">
                    <div className="col-9">
                        <img height="65px" src={ConsobLogo} alt="Consob Logo"/>
                    </div>
                    <div className="col-1 my-auto text-center navbar-divider-white">
                        <LogoutIcon onClick={openConfirmModalLogout} sx={{ml: 3}} className="color-white pointer"/>
                    </div>
                    <Tooltip placement="bottom" title={userInformation} arrow>
                        <div className="pointer col-2 text-center my-auto color-white">
                            {props.user.given_name} {props.user.family_name}
                        </div>
                    </Tooltip>
                </div>
                :
                <div id="top-row" className="row col-12">
                    <div className="col-7">
                        <img height="65px" src={ConsobLogo} alt="Consob Logo"/>
                    </div>
                    <div className="col-1 my-auto text-center navbar-divider-white">
                        <LogoutIcon onClick={openConfirmModalLogout} sx={{ml: 3}} className="color-white pointer"/>
                        <SettingsIcon onClick={goToConfig} sx={{ml: 3}} className="color-white pointer"/>
                    </div>
                    <Tooltip placement="bottom" title={userInformation} arrow>
                        <div className="pointer col-2 text-center my-auto color-white">
                            {props.user.given_name} {props.user.family_name}
                        </div>
                    </Tooltip>
                    <Select
                        className='col-2 my-auto'
                        value={role}
                        disabled = {notHomepage}
                        size='small'
                        sx={{
                            background:"rgb(241, 247, 255)",
                            borderRadius:"12px",
                        }}
                        onChange={(event => {roleChange(event.target.value)})}>
                        {roleList.map((choice) => {
                            return <MenuItem key={choice} value={choice}>
                                {choice}
                            </MenuItem>
                        })}
                    </Select>
                </div>
            }
            <Dialog
                open={open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">
                {'Logout'}
                </DialogTitle>
                <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {"Sei sicuro di voler uscire dall'applicazione?"}
                </DialogContentText>
                </DialogContent>
                <DialogActions>
                <Button onClick={handleCancel}>Annulla</Button>
                <Button onClick={handleConfirm} autoFocus>
                    LogOut
                </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default Navbar;
